import { render, staticRenderFns } from "./CreateOrganizationModule.vue?vue&type=template&id=cf05e030&scoped=true"
import script from "./CreateOrganizationModule.vue?vue&type=script&lang=js"
export * from "./CreateOrganizationModule.vue?vue&type=script&lang=js"
import style0 from "./CreateOrganizationModule.vue?vue&type=style&index=0&id=cf05e030&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf05e030",
  null
  
)

export default component.exports